export const data2_1 = [{
    name: 'Days 日数',
    name_code: "Days",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Total Available Rooms 总房间数量',
    name_code: "Total_Available_Rooms",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Total Rooms Occupied 总出租房',
    name_code: "Total_Rooms_Occupied",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Occupancy % 出租率%',
    name_code: "Occupancy",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Average Room Rate 平均每天房价',
    name_code: "Average_Room_Rate",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'RevPAR 单房产值',
    name_code: "RevPAR",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Revenue 收入',
    name_code: "Revenue",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Rooms 客房收入',
    name_code: "Rooms",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Food & Beverage 餐饮收入',
    name_code: "Food_Beverage",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Other Operated Departments 其它部门收入',
    name_code: "Other_Operated_Departments",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Total Revenues 总收入',
    name_code: "Total_Revenues",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Cost of Sales 销售成本',
    name_code: "Cost_of_Sales",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Food & Beverage 餐饮成本',
    name_code: "Food_Beverage",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Other Operated Departments 其它部门成本',
    name_code: "Other_Operated_Departments",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Total Cost of Sales 总成本',
    name_code: "Total_Cost_of_Sales",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Payroll Expenses 工资福利',
    name_code: "Payroll_Expenses",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Rooms 客房',
    name_code: "Rooms",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Food & Beverage 餐饮',
    name_code: "Food_Beverage",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Other Operated Departments 其它部门',
    name_code: "Other_Operated_Departments",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Total Payroll Expenses 总工资福利',
    name_code: "Total_Payroll_Expenses",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Provision for O.E. 营运工具預提',
    name_code: "Provision_for_O.E.",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Rooms 客房',
    name_code: "Rooms",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Food & Beverage 餐饮',
    name_code: "Food_Beverage",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Other Operated Departments 其它部门',
    name_code: "Other_Operated_Departments",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Total Provision for O.E. 总营运工具預提',
    name_code: "Total_Provision_for_O.E.",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Other Expenses 其它费用',
    name_code: "Other_Expenses",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Rooms 客房',
    name_code: "Rooms",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Food & Beverage 餐饮',
    name_code: "Food_Beverage",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Other Operated Departments 其它部门',
    name_code: "Other_Operated_Departments",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Total Other Expenses 总其它费用',
    name_code: "Total_Other_Expenses",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Total Department Cost/Expenses 部门总成本和费用',
    name_code: "Total_Department_Cost/Expenses",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Departmental Profit 部门利润',
    name_code: "Departmental_Profit",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Rooms 客房',
    name_code: "Rooms",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Food & Beverage 餐饮',
    name_code: "Food_Beverage",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Other Operated Departments 其它部门',
    name_code: "Other_Operated_Departments",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Total Departmental profit 总部门利润',
    name_code: "Total_Departmental_profit",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Undistributed Operating Expenses 未分配部门费用',
    name_code: "Undistributed_Operating_Expenses",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Payroll Expenses 工资福利',
    name_code: "Payroll_Expenses",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Administration & General 行政办',
    name_code: "Administration_General",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Human Resources 人力资源部',
    name_code: "Human_Resources",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Sales & Marketing 市场销售部',
    name_code: "Sales_Marketing",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Property Operation & Maintenance 工程部',
    name_code: "Property_Operation_Maintenance",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Total Payroll Expenses 总工资福利',
    name_code: "Total_Payroll_Expenses",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Other Expenses 其它费用',
    name_code: "Other_Expenses",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Administration & General 行政办',
    name_code: "Administration_General",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Human Resources 人力资源部',
    name_code: "Human_Resources",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Sales & Marketing 市场销售部',
    name_code: "Sales_Marketing",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Property Operation & Maintenance 工程部',
    name_code: "Property_Operation_Maintenance",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Energy Costs 能源费用',
    name_code: "Energy_Costs",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Total Other Expenses 总其它费用',
    name_code: "Total_Other_Expenses",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Total Undistributed Operating Expenses 未分配部门费用总计',
    name_code: "Total_Undistributed_Operating_Expenses",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Income After Undistributed Operating Expenses',
    name_code: "Income_After_Undistributed_Operating_Expenses",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Insurance 保险',
    name_code: "Insurance",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Base Fee 基本管理费',
    name_code: "Base_Fee",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Brand Service Fee 品牌维护费',
    name_code: "Brand_Service_Fee",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Gross Operating Profit/(Loss) 总毛利润/(亏损)',
    name_code: "Gross_Operating_Profit/(Loss)",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Other Deductions 其它扣除',
    name_code: "Other_Deductions",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Incentive Fees 奖励性管理费',
    name_code: "Incentive_Fees",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Reserve for Capital Expenditure 固定资产备用',
    name_code: "Reserve_for_Capital_Expenditure",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Others 其它',
    name_code: "Others",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Total Other Deductions 其它扣除总计',
    name_code: "Total_Other_Deductions",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: "Owner's Profit/(Loss) 业主利润/(亏损)",
    name_code: "Owner's Profit/(Loss) 业主利润/(亏损)",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Index',
    name_code: "Index",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Departmental Income - Rooms',
    name_code: "Departmental_Income_Rooms",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Departmental Income - F&B',
    name_code: "Departmental_Income_F&B",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Payroll Percentage for Operating Departments',
    name_code: "Payroll_Percentage_for_Operating_Departments",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Payroll Percentage for Undistributed Departments',
    name_code: "Payroll_Percentage_for_Undistributed_Departments",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Total Labor Cost Percentage',
    name_code: "Total_Labor_Cost_Percentage",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Tota F&B Cost Percentage',
    name_code: "Tota_F&B_Cost_Percentage",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Total Energy Cost Percentage',
    name_code: "Total_Energy_Cost_Percentage",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Three Main Costs Percentage',
    name_code: "Three_Main_Costs_Percentage",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Monthly Cost and Expenses - Rooms',
    name_code: "Monthly_Cost_and_Expenses_Rooms",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Monthly Cost and Expenses - F&B',
    name_code: "Monthly_Cost_and_Expenses_F&B",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Breakeven Point',
    name_code: "Breakeven_Point",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}, {
    name: 'Labor Cost',
    name_code: "Labor_Cost",
    Jan_actual: 0,
    Jan_forecast: 0,
    Jan_budget: 0,
    Feb_actual: 0,
    Feb_forecast: 0,
    Feb_budget: 0,
    Mar_actual: 0,
    Mar_forecast: 0,
    Mar_budget: 0,
    total: 0,
    cover: 0,
}]


// WEBPACK FOOTER //
// ./src/components/charter/first/data.js